import { getItem } from './local-storage';

export default function storedColumns(allColumns, defaultColumns, storedName) {
  const parsedItems = JSON.parse(getItem(storedName));
  const columnHeaders = parsedItems
    ? parsedItems.map(storedColumn => storedColumn.Label || storedColumn.Header)
    : defaultColumns.map(
        storedColumn => storedColumn.Label || storedColumn.Header,
      );
  const filteredColumns = allColumns
    .filter(column => columnHeaders.includes(column.Label || column.Header))
    .sort(
      (a, b) =>
        columnHeaders.indexOf(a.Label || a.Header) -
        columnHeaders.indexOf(b.Label || b.Header),
    );
  return filteredColumns;
}
